import { CircularProgress } from 'components/overlays';
import styles from './RangeDetails.module.css';
import { Box, Button, Card, CardContent, IconButton, InputAdornment, TextField, Typography } from '@mui/material';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { useEffect, useState } from 'react';

import { IconButton as IconBtn } from "components/buttons";
import { Done, HideSource } from '@mui/icons-material';
import { ConfirmationDialog } from 'components/dialogs';
import { RangeField } from 'components/forms';

const RangeDetails = ({id, name, start, disabled=false, end, setLoading, editRange, addRange}) => {
  
  const [currentName, setCurrentName] = useState(name ?? `Диапазон от ${new Date().toLocaleDateString()}`);
  const [currentStart, setCurrentStart] = useState(start ?? '');
  const [currentEnd, setCurrentEnd] = useState(end ?? '');
  const [focusedStart, setFocusedStart] = useState(false);
  const [focusedEnd, setFocusedEnd] = useState(false);

  useEffect(() => {
    setCurrentName(name ?? `Диапазон от ${new Date().toLocaleDateString()}`);
    setCurrentStart(start ?? '');
    setCurrentEnd(end ?? '');
  }, [name, start, end]);

  const [open, setOpen] = useState(false);
  const okHandler = (e) => {
    editRange({id, body: {disabled: !disabled}})
    setOpen(false);
  };
  const cancelHandler = (e) => setOpen(false);

  const isAddingMode = () => !id;
  const getSaveButtonText = () => name ? 'Изменить диапазон' : 'Добавить новый диапазон';
  
  const isValid = () => {
    if(!currentName) return false;
    const _start = parseInt(currentStart); 
    if((currentStart.length < 8) || isNaN(_start) || _start < 0) return false;
    const _end = parseInt(currentEnd);
    if((currentEnd.length < 8) || isNaN(_end) || _end < 0) return false;

    if(_start > _end) return false;

    if(!isAddingMode()) {
      return !(name===currentName && start===currentStart && end===currentEnd);
    }
    return true;
  };

  const makeBody = () => {
    if(isAddingMode()) {
      return  {body: {name: currentName, start: currentStart, end: currentEnd}};
    }
    
    const result = {id, body: {}};
    if(name != currentName) result.body.name = currentName;
    if(start != currentStart) result.body.start = currentStart;
    if(end != currentEnd) result.body.end = currentEnd;
    return result;
    
      
  };

  const saveRange = () => {
    return isAddingMode() ? addRange(makeBody()) : editRange(makeBody());
  };

  const isSaveButtonDisabled = () => !isValid();
  

  const changeName = (event) => {
    setCurrentName(event.target.value); 
  };

  const getDisableButtonIcon = () => disabled ? <Done /> : <HideSource />;

  return (
    <div className={styles.details}>
      <div className={styles.content}>
        <CircularProgress open={false}/>
        <Card sx={{height: '100%'}}>
          <CardContent>
            <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}}>
              <TextField
                fullWidth
                label='Наименование диапазона'
                value={currentName}
                InputProps={{
                  endAdornment: currentName && (
                    <IconButton onClick={()=>setCurrentName('')}>
                      <CloseOutlinedIcon/>
                    </IconButton>
                  )
                }}
                onChange={changeName}
              />
              <IconBtn
                className={styles.disableButton}
                handler={() => setOpen(true)}
                text={disabled ? 'Включить диапазон' : 'Отключить диапазон'}
                variant="outlined"  
                iconCmp={getDisableButtonIcon()}
                disabled={isAddingMode()}
              />
              <ConfirmationDialog 
                title={disabled ? 'Включить диапазон' : 'Отключить диапазон'}
                text={<span>{disabled ? 'Включить диапазон' : 'Отключить диапазон'} <b>{name}</b>? {disabled ? 'Кассы из этого диапазона будут обрабатываться кабинетом.' : 'Кассы из этого диапазона перестанут обрабатываться кабинетом.'}</span>}
                open={open}
                onOk={okHandler}
                onCancel={cancelHandler}
              />
            </Box>
            <Box my={3} sx={{'display': 'flex', alignItems: 'center'}}>
              <TextField 
                label='Начало диапазона'
                value={currentStart}
                error={currentStart.length > 0 && currentStart.length < 8}
                fullWidth 
                inputProps={{style: {textAlign: 'center', fontFamily: 'PT Mono'}}}
                InputProps={{
                  inputComponent: RangeField
                }}
                InputLabelProps={{
                  shrink: focusedStart || Boolean(currentStart)
                }}
                onFocus={() => setFocusedStart(true)}
                onBlur={() => setFocusedStart(false)}
                onChange={(e) => setCurrentStart(e.target.value)}
              />
              <Typography mx={2} variant='h5'>-</Typography>
              <TextField 
                label='Конец диапазона'
                value={currentEnd}
                error={currentEnd.length > 0 && currentEnd.length < 8}
                fullWidth 
                inputProps={{style: {textAlign: 'center', fontFamily: 'PT Mono'}}}
                InputProps={{
                  inputComponent: RangeField
                }}
                InputLabelProps={{
                  shrink: focusedEnd || Boolean(currentEnd)
                }}
                onFocus={() => setFocusedEnd(true)}
                onBlur={() => setFocusedEnd(false)}
                onChange={(e) => setCurrentEnd(e.target.value)}
              />
            </Box>
            <Button
              fullWidth
              disabled={isSaveButtonDisabled()}
              startIcon={<SaveOutlinedIcon/>}
              color='error'
              variant='contained'
              mb={3}
              onClick={() => saveRange()}
            >{getSaveButtonText()}</Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default RangeDetails;